export default function BasketFixedService() {
    var fn = this;

    return fn;
}
